export default function getItemsFromPath(context: any) {
  return context.keys().reduce((files: any, key: string) => {
    files[key.replace('./', '')] = context(key).default
    return files
  }, {})
}
